var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70711 0.792893C10.0976 1.18342 10.0976 1.81658 9.70711 2.20711L4.70711 7.20711C4.31658 7.59763 3.68342 7.59763 3.29289 7.20711L0.792893 4.70711C0.402369 4.31658 0.402369 3.68342 0.792893 3.29289C1.18342 2.90237 1.81658 2.90237 2.20711 3.29289L4 5.08579L8.29289 0.792893C8.68342 0.402369 9.31658 0.402369 9.70711 0.792893Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.e363588b62d1a7fad399df29a598688b.svg";
export { ForwardRef as ReactComponent };